import React, { useState } from 'react';
import { useRecoilState } from 'recoil';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import {
  Tabs,
  Switch
} from 'antd';
import { APIProvider } from '@vis.gl/react-google-maps';
import { H1 } from '../../shared-components/typography/Title';
import MainPage from '../../shared-components/main-page/MainPage';
import AmaDashboardAnalytics from './shared-components/AmaDashboardAnalytics';
import AmaDashboardLiveMap from './shared-components/AmaDashboardLiveMap';
import AmaDashboardOtp from './shared-components/AmaDashboardOtp';
import { amaDashboardCurrentTabAtom, amaDashboardShowMphAtom, amaDashboardLiveMapSettingsAtom } from '../../../atoms/Atoms';
import Select from '../../shared-components/form/Select';
import envConfig from '../../../envConfig';

function AmaDashboard() {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useRecoilState(amaDashboardCurrentTabAtom);
  const [showMph, setShowMph] = useRecoilState(amaDashboardShowMphAtom);
  const [mapSettings, setMapSettings] = useRecoilState(amaDashboardLiveMapSettingsAtom);

  return (
    <MainPage>
      <div className="lg:flex">
        <H1 text={`AMA - ${t('dashboard')}`} />
        {/* {currentTab === '1' && ( 
          <>
            <div className="ml-auto mr-2 flex">
              <Select
                className="w-full lg:w-64"
                label={t('map_type')}
                value={mapSettings.type}
                onChange={(obj) => setMapSettings({
                  ...mapSettings,
                  type: obj.target.value
                })}
                options={[
                  {
                    key: 'roadmap',
                    value: 'roadmap',
                    text: t('default'),
                  },
                  {
                    key: 'hybrid',
                    value: 'hybrid',
                    text: t('terrain'),
                  },
                ]}
              />
              <div className="lg:mt-2 ml-2">
                <strong>{t('show_traffic')}</strong>
                <Switch
                  className="ml-1"
                  checked={mapSettings.showTraffic}
                  onChange={(checked) => setMapSettings({
                    ...mapSettings,
                    showTraffic: checked
                  })}
                />
              </div>
            </div>
          </>
        )} */}
        {/* <div className={currentTab !== '1' ? 'mt-2 ml-auto' : 'mt-2'}> */}
        <div className="ml-auto mt-2">
          <strong>{t('use_mph')}</strong>
          <Switch
            className="ml-1"
            checked={showMph}
            onChange={(checked) => setShowMph(checked)}
          />
        </div>
      </div>
      <APIProvider apiKey={envConfig.GoogleApiKey} libraries={['marker']}>
        <Tabs activeKey={currentTab} onChange={(key) => setCurrentTab(key)} className="h-full">
          <Tabs.TabPane key="1" tab={t('live_map')} className="full-height-tab">
            <AmaDashboardLiveMap />
          </Tabs.TabPane>
          <Tabs.TabPane key="2" tab={t('on_time_performance')}>
            <AmaDashboardOtp />
          </Tabs.TabPane>
          <Tabs.TabPane key="0" tab={t('dashboard')}>
            <AmaDashboardAnalytics />
          </Tabs.TabPane>
        </Tabs>
      </APIProvider>
    </MainPage>
  );
}

export default AmaDashboard;
